import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=4f0a8e0c"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"
import style0 from "./Editar.vue?vue&type=style&index=0&id=4f0a8e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports